import * as React from 'react';
import { connect } from 'react-redux';
import { OperationMessage } from '../../presentational/application/OperationMessage';
import * as App from 'application';
import { IRootState } from 'store';
import { ROUTES } from 'config';
import { Redirect } from 'react-router';

export interface IEmailConfirmationProps {
	isAuthenticated: boolean;
	verifyEmailConfimation(): Promise<boolean>;
	raiseConfirmationMessage(message);
}

const mapStateToProps = (state: IRootState) => ({

});

const mapDispatchToProps = (dispatch) => ({
	verifyEmailConfimation: () => App.EmailConfirmation.verify(dispatch),
	raiseConfirmationMessage: (message) => App.Operation.onSuccess(message, dispatch),
})

/** Handler to check if user account has emailed confirmed */
class EmailConfirmationComponent extends React.Component<IEmailConfirmationProps> {

	componentWillMount() {
		// Make sure this only runs once
		if (this.props.isAuthenticated) {
			this.props.verifyEmailConfimation();
		}
	}

	render() {
		if (this.props.isAuthenticated) {
			return <OperationMessage message="Confirming Email..." />;
		}
		else {
			this.props.raiseConfirmationMessage("Thank you for confirming your email. Please log in to access the portal");
		}
		return <Redirect to={ROUTES.HOME} />;
	}
}

export const EmailConfirmation = connect(mapStateToProps, mapDispatchToProps)(EmailConfirmationComponent);



// WEBPACK FOOTER //
// ./src/components/containers/handlers/EmailConfirmationHandler.tsx